import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-restore-version-confirmation-dialog',
    templateUrl: './restore-version-confirmation-dialog.component.html',
    styleUrls: ['./restore-version-confirmation-dialog.component.css'],
    standalone: false,
})
export class RestoreVersionConfirmationDialogComponent {
    constructor(private dialogRef: MatDialogRef<RestoreVersionConfirmationDialogComponent>) {}

    cancel() {
        this.dialogRef.close();
    }

    restore() {
        this.dialogRef.close(true);
    }
}
